// ACTION CREATOR FETCH_NODE_INFO_MAP_PAGE
export const FETCH_NODE_INFO_MAP_PAGE = 'FETCH_NODE_INFO_MAP_PAGE';

// ACTION CREATOR fetchNodeInfoMapPage
export const fetchNodeInfoMapPage = (value, backend) => ({
  type: FETCH_NODE_INFO_MAP_PAGE,
  value,
  backend,
});

// ACTION CREATOR FETCH_NODE_INFO_TAB_PAGE
export const FETCH_NODE_INFO_TAB_PAGE = 'FETCH_NODE_INFO_TAB_PAGE';

// ACTION CREATOR fetchNodeInfoTabPage
export const fetchNodeInfoTabPage = (value, backend) => ({
  type: FETCH_NODE_INFO_TAB_PAGE,
  value,
  backend,
});

// ACTION CREATOR SET_SAVE_MAP_NODE_INFO_PAGE
export const SET_SAVE_MAP_NODE_INFO_PAGE = 'SET_SAVE_MAP_NODE_INFO_PAGE';

// ACTION CREATOR setSaveMapNodeInfoPage
export const setSaveMapNodeInfoPage = (value) => ({
  type: SET_SAVE_MAP_NODE_INFO_PAGE,
  value,
});

// ACTION CREATOR SET_SAVE_TAB_NODE_INFO_PAGE
export const SET_SAVE_TAB_NODE_INFO_PAGE = 'SET_SAVE_TAB_NODE_INFO_PAGE';

// ACTION CREATOR setSaveTabNodeInfoPage
export const setSaveTabNodeInfoPage = (value) => ({
  type: SET_SAVE_TAB_NODE_INFO_PAGE,
  value,
});

// ACTION CREATOR SET_LOADING_NODE_INFO_MAP
export const SET_LOADING_NODE_INFO_MAP = 'SET_LOADING_NODE_INFO_MAP';

// ACTION CREATOR setLoadingNodeInfoMap
export const setLoadingNodeInfoMap = (value) => ({
  type: SET_LOADING_NODE_INFO_MAP,
  value,
});

// ACTION CREATOR SET_LOADING_NODE_INFO_TAB
export const SET_LOADING_NODE_INFO_TAB = 'SET_LOADING_NODE_INFO_TAB';

// ACTION CREATOR setLoadingNodeInfoTab
export const setLoadingNodeInfoTab = (value) => ({
  type: SET_LOADING_NODE_INFO_TAB,
  value,
});

// ACTION CREATOR SET_SAVE_NODE_INFO_MARKER_COMPONENT
export const SET_SAVE_NODE_INFO_MARKER_COMPONENT = 'SET_SAVE_NODE_INFO_MARKER_COMPONENT';

// ACTION CREATOR setSaveNodeInfoMakerComponent
export const setSaveNodeInfoMakerComponent = (value) => ({
  type: SET_SAVE_NODE_INFO_MARKER_COMPONENT,
  value,
});

// ACTION CREATOR SET_SAVE_NODE_INFO_MARKER_STATIC
export const SET_SAVE_NODE_INFO_MARKER_STATIC = 'SET_SAVE_NODE_INFO_MARKER_STATIC';

// ACTION CREATOR setSaveNodeInfoMakerStatic
export const setSaveNodeInfoMakerStatic = (value) => ({
  type: SET_SAVE_NODE_INFO_MARKER_STATIC,
  value,
});

// ACTION CREATOR SET_SAVE_NODE_INFO_MARKER_ARRAY
export const SET_SAVE_NODE_INFO_MARKER_ARRAY = 'SET_SAVE_NODE_INFO_MARKER_ARRAY';

// ACTION CREATOR setSaveNodeInfoMakerArray
export const setSaveNodeInfoMakerArray = (value) => ({
  type: SET_SAVE_NODE_INFO_MARKER_ARRAY,
  value,
});
